/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Stok_SenkronizasyonInputs */

const tr_faq_a_stok_senkronizasyon = /** @type {(inputs: Faq_A_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stok verileri varsayılan olarak her 30 dakikada bir güncellenir. Otomasyonlar sayfasından bu aralığı değiştirebilir ya da Stok sayfasındaki Yenile butonuyla anlık güncelleme başlatabilirsin. Trendyol ve Hepsiburada anlık stok push'u da destekler; sipariş onaylandığında stok anında düşer.`)
};

const en_faq_a_stok_senkronizasyon = /** @type {(inputs: Faq_A_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock is updated every 30 minutes by default. You can change this interval on the Automations page or trigger a manual refresh from the Stock page. For Trendyol and Hepsiburada stock is also pushed instantly when an order is approved.`)
};

const de_faq_a_stok_senkronizasyon = /** @type {(inputs: Faq_A_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Bestand wird standardmäßig alle 30 Minuten aktualisiert. Du kannst das Intervall auf der Automatisierungsseite ändern oder manuell aktualisieren. Bei Trendyol und Hepsiburada wird der Bestand auch sofort nach Bestellgenehmigung gesendet.`)
};

const ru_faq_a_stok_senkronizasyon = /** @type {(inputs: Faq_A_Stok_SenkronizasyonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По умолчанию остаток обновляется каждые 30 минут. Интервал можно изменить на странице Автоматизации или запустить обновление вручную. Для Trendyol и Hepsiburada остаток также обновляется мгновенно при одобрении заказа.`)
};

/**
* | output |
* | --- |
* | "Stock is updated every 30 minutes by default. You can change this interval on the Automations page or trigger a manual refresh from the Stock page. For Trend..." |
*
* @param {Faq_A_Stok_SenkronizasyonInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_stok_senkronizasyon = /** @type {((inputs?: Faq_A_Stok_SenkronizasyonInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Stok_SenkronizasyonInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_stok_senkronizasyon(inputs)
	if (locale === "de") return de_faq_a_stok_senkronizasyon(inputs)
	if (locale === "ru") return ru_faq_a_stok_senkronizasyon(inputs)
	return tr_faq_a_stok_senkronizasyon(inputs)
});